import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProdutoFechamento } from '../../models/produto-fechamento';
import { FechamentoFinanceiroService } from '../../services/fechamento-financeiro.service';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-produto-fechamento-modal',
  templateUrl: './produto-fechamento-modal.component.html',
  styleUrls: ['./produto-fechamento-modal.component.scss']
})
export class ProdutoFechamentoModalComponent implements OnInit {
  idFechamento: number;
  produtos: ProdutoFechamento[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<void>,
    @Inject(MAT_DIALOG_DATA) public data: {idFechamento: number},
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService
  ) {
    this.idFechamento = data.idFechamento;
  }

  ngOnInit(): void {
    this.buscarProdutosDoFechamento();
  }

  buscarProdutosDoFechamento() {
    this.carregandoService.mostra('buscarProdutosDoFechamento');

    this.fechamentoFinanceiroService.consultarProdutosDoFechamento(this.idFechamento).subscribe(
      (produtos: ProdutoFechamento[]) => {
        this.produtos = produtos;
        this.carregandoService.esconde('buscarProdutosDoFechamento');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarProdutosDoFechamento');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
